
document.addEventListener('DOMContentLoaded', function() {
    window.setTimeout(function() {
        const navLinks = document.querySelectorAll('.mega-menu__list--tabs div:has(button)');

        console.log('here', navLinks);
            
        navLinks.forEach(link => {
            link.addEventListener('mousedown', function() {
                let hasDisabledButton = link.querySelector('button[disabled]');
                if (hasDisabledButton) {
                    let url = link.dataset.link;
                    window.location.href = url;
                }
            })
        })
    
    }, 1000)
})